import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { SectorOverviewItem, SectorPolygon, Address, Street } from '../../models';
import { SectorApiService } from './sector.api.service';

@Injectable()
export class SectorDomainService {
    constructor(private sectorApiService: SectorApiService) { }

    public getSectorById(sectorId: string): Observable<SectorPolygon> {
        return this.sectorApiService.getSectorById(sectorId);
    }

    public getSectorsByIds(sectorIds: string[]): Observable<SectorPolygon[]> {
        return this.sectorApiService.getSectorsByIds(sectorIds);
    }

    public getAddressesBySectorId(sectorId: string): Observable<Address[]> {
        return this.sectorApiService.getAddressesBySectorId(sectorId);
    }
    public getStreetsBySectoriD(sectorId: string): Observable<Street[]> {
        return this.sectorApiService.getStreetsBySectoriD(sectorId);
    }

    public getSectorOverviewByIds(sectorIds: string[]): Observable<SectorOverviewItem[]> {
        return this.sectorApiService.getSectorOverviewByIds(sectorIds);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/sector/sector.domain.service.ts